import { DisplayMessage } from "../../../../../services/helpers";
import {
	DeleteRequest,
	GetRequest,
	UpdateRequest,
} from "../../../../../services/requestHelpers";
import { HttpMethods } from "../../../../../utils/constants";
import {ChecklistManagementBaseUrl} from "../../../../../constants/apiUrls";

export const baseUrl = ChecklistManagementBaseUrl();

export const getChecklistTemplates = async () => {
	const response = await GetRequest(baseUrl);
	var result = await response.json();

	if (!response.ok) {
		result.errors.forEach((error) => DisplayMessage(error, "error"));

		return undefined;
	}

	return result;
};

export const createChecklistTemplate = async (data) => {
	const response = await UpdateRequest(`${baseUrl}`, data, HttpMethods.Post);
	var result = await response.json();

	if (!response.ok) {
		result.errors.forEach((error) => DisplayMessage(error, "error"));

		return undefined;
	}

	return result;
};

export const deleteChecklistTemplate = async (id) => {
	const response = await DeleteRequest(`${baseUrl}/${id}`);

	if (!response.ok) {
		response.json().then((result) => {
			result.errors.forEach((error) => DisplayMessage(error, "error"));
		});
	}

	return response.ok;
};

export const getBrands = async (objectType) => {
	const url = `/api/mobopro/v1/brands?objectType=${objectType}`;
	const response = await GetRequest(url);
	const result = await response.json();

	if (!response.ok) {
		result.errors.forEach((error) => DisplayMessage(error, "error"));

		return undefined;
	}

	return result;
};

export const getChecklistTemplateById = async (templateId) => {
	const url = `${baseUrl}/${templateId}`;
	const response = await GetRequest(url);
	const result = await response.json();

	if (!response.ok) {
		return undefined;
	}

	return result;
};

export const translateChecklistTemplateWithAI = async (requestBody) => {
	const response = await UpdateRequest(
		"/api/mobopro/v1/translate",
		JSON.stringify(requestBody),
		HttpMethods.Post
	);
	if (!response.ok) {
		let result;
		try {
			result = await response.json();
			if (result?.errors) {
				result.errors.forEach((error) => DisplayMessage(error, "error"));
			}
		} catch {}
		throw new Error("Translation API error");
	}
	return await response.json();
};

export const updateChecklistTemplateHeaderImage = async (templateId, blobRelativePath) => {
	const file = blobRelativePath ? { blobRelativePath, type: 1 } : null;
	const body = JSON.stringify({ headerImageFile: file });

	const response = await UpdateRequest(`${baseUrl}/${templateId}`, body, HttpMethods.Patch);

	if (!response.ok) {
		const result = await response.json();
		if (result?.errors) {
			result.errors.forEach((error) => DisplayMessage(error, "error"));
		}
		return undefined;
	}

	return await response.json();
};